require('./brokerAlreadyPerformedMiFIDTest.scss');

const PropTypes = require('prop-types');

// @vendors
const React = require('react');
const moment = require('moment');

// @commons
const { ContentBox } = require('commonsComponents/contentBox');
const { OKButton } = require('components/commons/OKButton/OKButton');

// @constants
const { DATE_FORMAT_COMPLETE, HYPHEN } = require('constants/index');

// @helpers
const { formatText, FormattedText } = require('core/i18n').i18n;
const DateHelper = require('utilities/dateHelper');

const BrokerAlreadyPerformedMiFIDTest = props => {
    const { date } = props;
    const contentBoxTitle = formatText('broker-convenienceMifidTestAlreadyPerformedTestTitle');
    const title = formatText('broker-convenienceMifidTestAlreadyPerformedTestSubtitle');
    const dateOfTest =
        date && moment(date).isValid()
            ? DateHelper.buildFormattedDate(date, DATE_FORMAT_COMPLETE)
            : HYPHEN;

    return (
        <ContentBox title={contentBoxTitle} titleSeparator={true}>
            <h1 className="broker-already-performed-mifid-test__title">{title}</h1>
            <p className="broker-already-performed-mifid-test__info">
                {props.disclaimerText}
            </p>
            <div className="broker-already-performed-mifid-test__subtitle">
                <FormattedText value="consultMiFID-dateLastEvaluation" format="uppercase"/>
            </div>
            <div className="broker-already-performed-mifid-test__info-bold">
                {dateOfTest}
            </div>
            <footer className="broker-already-performed-mifid-test__footer">
                <div className="row">
                    <div className="col-xs-6">
                        <OKButton
                            modifier="link-ghost"
                            onClick={props.onCancel}
                        >
                            <FormattedText value="broker-convenienceMifidTestAlreadyPerformedTestSuccessCancel" />
                        </OKButton>
                    </div>
                    <div className="col-xs-6 text-right">
                        <OKButton modifier="secondary" onClick={props.onContinueOperation}>
                            <FormattedText value="broker-convenienceMifidTestAlreadyPerformedTestSuccessContinue" />
                        </OKButton>
                    </div>
                </div>
            </footer>
        </ContentBox>
    );
};

BrokerAlreadyPerformedMiFIDTest.propTypes = {
    onContinueOperation: PropTypes.func.isRequired,
    disclaimerText: PropTypes.string.isRequired,
    onCancel: PropTypes.func,
    date: PropTypes.string,
};

module.exports = BrokerAlreadyPerformedMiFIDTest;